// app/javascript/controllers/mortgage_calculator_controller.js
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mortgage-calculator"
export default class extends Controller {
  static targets = [
    "type",
    "term",
    "principal",
    "interestRate",
    "amountOverride",
    "periodicity",
    "calculatedAmount"
  ]

  connect() {
    this.update()
  }

  update() {
    // NEED TO TAKE INTO ACCOUNT TYPE AS WELL
    // PERHAPS CALCULATE HERE OR CALLBACK TO BACKEND TO CALCULATE BASED ON TYPE
console.log(this.typeTarget.value)

    if (this.typeTarget.value === "repayment") {
      this.calculatedAmountTarget.closest(".form-group").classList.add("d-none");
      return
    }
    else {
      this.calculatedAmountTarget.closest(".form-group").classList.remove("d-none");
    }

    const principal = parseFloat(this.principalTarget.value) || 0
    const annualRate = parseFloat(this.interestRateTarget.value) || 0
    const periodicity = "monthly" // this.periodicityTarget.value // 'monthly' or 'weekly'

    let payment = 0
    let suffixPeriod = ""

    if (periodicity !== 'one-off' && principal > 0 && annualRate > 0) {
      // Convert annual interest rate percentage to decimal
      const ratePerYear = annualRate / 100

      if (periodicity === "monthly") {
        const monthlyRate = ratePerYear / 12.0
        payment = principal * monthlyRate
        suffixPeriod = "per month"
      } else if (periodicity === "weekly") {
        const weeklyRate = ratePerYear / 52.0
        payment = principal * weeklyRate
        suffixPeriod = "per week"
      } else if (periodicity === "annually") {
        const annualRate = ratePerYear / 1.0
        payment = principal * annualRate
        suffixPeriod = "per year"
      } else if (periodicity === "daily") {
        const dailyRate = ratePerYear / 365.25
        payment = principal * dailyRate
        suffixPeriod = "per day"
      }

      this.calculatedAmountTarget.textContent =
        `Calculated collection amount: £${payment.toFixed(2)} ${suffixPeriod}`
    }
    else {
      this.calculatedAmountTarget.textContent =
        `Calculated collection amount: -`

    }

  }
}
